import AbstractIframe from "../../modules/Iframes/AbstractIframe";
import ParametresDeCompte from "../../modules/home/ui/ParametresDeCompte";
import config from "../Config";

const routesConfig = [
  {
    path: "/changementmdp",
    component: ParametresDeCompte,
    roles: [
      "ROLE_VUPORTUARIA_MEAD",
      "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
      "ROLE_VUPORTUARIA_ADMIN",
      "ROLE_VUPORTUARIA_OPERADOR",
      "ROLE_VUPORTUARIA_FACTURAS_CLIENTE",
      "ROLE_VUPORTUARIA_FACTURAS_EMISOR",
      "ROLE_VUPORTUARIA_FREIGHT_FORWARDER",
    ],
  },
  {
    path: "ManifesteMead/Gestion",
    component: AbstractIframe,
    props: { url: config.manifesteMead + "/gestionMead?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "ManifesteMead/Consultation",
    component: AbstractIframe,
    props: { url: config.manifesteMead + "/gestionMead?" },
    roles: ["ROLE_VUPORTUARIA_ADMIN"],
  },

  {
    path: "ManifesteMead/Nouveau",
    component: AbstractIframe,
    props: { url: config.manifesteMead + "/createEnteteMead?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "OperationImportation/PreavisArrive",
    component: AbstractIframe,
    props: { url: config.pravisArrive + "/gestionPreavis?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  // Bon à délivrer mead
  {
    path: "BadMead/Gestion",
    component: AbstractIframe,
    props: { url: config.badMead + "/gestion-bad?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Bad/Validation",
    component: AbstractIframe,
    props: { url: config.validationBAD + "?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "BadMead/Consultation",
    component: AbstractIframe,
    props: { url: config.badMead + "/consultation-bad?" },
    roles: ["ROLE_VUPORTUARIA_ADMIN", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER", "ROLE_VUPORTUARIA_MEAD"],
  },
  // Bon à délivrer maritime
 
  {
    path: "dsCombine/gestion",
    component: AbstractIframe,
    props: { url: config.dsCombine + "/searchCombineEnteteMead?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "dsCombine/consultation",
    component: AbstractIframe,
    props: { url: config.dsCombine + "/searchCombineEnteteMeadModeConsultation?" },
    roles: ["ROLE_VUPORTUARIA_ADMIN", "ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "dsCombine/nouvelle-creation",
    component: AbstractIframe,
    props: { url: config.dsCombine + "/combineEnteteMead?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "dsCombine/gestion-caution",
    component: AbstractIframe,
    props: { url: config.dsCombine + "/parametrage/caution?" },
    roles: ["ROLE_VUPORTUARIA_ADMIN", "ROLE_VUPORTUARIA_MEAD"],
  },
  // {
  //   path: "Circuit/EtatApurement",
  //   component: AbstractIframe,
  //   props: { url: config.apurement + "?" },
  //   roles: ["ROLE_VUPORTUARIA_MEAD"],
  // },
  // {
  //   path: "Circuit/FicheSuiveuse",
  //   component: AbstractIframe,
  //   props: { url: config.ficheSuiv + "?" },
  //   roles: ["ROLE_VUPORTUARIA_MEAD"],
  // },
  // {
  //   path: "Consultation/AvisArrivee",
  //   component: AbstractIframe,
  //   props: { url: config.consultationAvis + "?" },
  //   roles: ["ROLE_VUPORTUARIA_MEAD"],
  // },
  // {
  //   path: "Consultation/ManifesteMaritime",
  //   component: AbstractIframe,
  //   props: { url: config.consultationManifesteMaritime + "?" },
  //   roles: ["ROLE_VUPORTUARIA_MEAD"],
  // },
  // {
  //   path: "Consultation/ManifesteExport",
  //   component: AbstractIframe,
  //   props: { url: config.consultationManifesteExport + "?" },
  //   roles: ["ROLE_VUPORTUARIA_MEAD"],
  // },
  // {
  //   path: "Consultation/BonSortie",
  //   component: AbstractIframe,
  //   props: { url: config.bonSortie + "?" },
  //   roles: ["ROLE_VUPORTUARIA_MEAD"],
  // },

  // Manifeste Aérien
  {
    path: "ManifesteAeriens/Nouveau",
    component: AbstractIframe,
    props: { url: config.manifesteAeriens + "/createEnteteAerien?" },
    roles: ["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"],
  },
  {
    path: "ManifesteAeriens/Gestion",
    component: AbstractIframe,
    props: { url: config.manifesteAeriens + "/searchAerien?" },
    roles: ["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"],
  },
  {
    path: "ManifesteAeriens/Consultation",
    component: AbstractIframe,
    props: { url: config.manifesteAeriens + "/searchAerien?" },
    roles: ["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE", "ROLE_VUPORTUARIA_ADMIN"],
  },

  // Terminal
  {
    path: "Terminal/BonADelivre/Aerien/Gestion",
    component: AbstractIframe,
    props: { url: config.terminalBadAerien + "/gestion-bad?" },
    roles: ["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Terminal/BonADelivre/Aerien/Consultation",
    component: AbstractIframe,
    props: { url: config.terminalBadAerien + "/consultation-bad?" },
    roles: ["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE", "ROLE_VUPORTUARIA_ADMIN", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  // Terminal - Freight Forwarder specific
  {
    path: "Terminal/ManifestesDepotage/Gestion",
    component: AbstractIframe,
    props: { url: config.manifesteDepotage + "/list-manifeste-import?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Terminal/ManifestesDepotage/Consultation",
    component: AbstractIframe,
    props: { url: config.manifesteDepotage + "/list-manifeste-import?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Terminal/Booking/Consultation",
    component: AbstractIframe,
    props: { url: config.booking + "/gestion?action=consult&" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Terminal/BadDSAutres/Gestion",
    component: AbstractIframe,
    props: { url: config.badDSAutres + "/gestion-bad?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Terminal/BadDSAutres/Consultation",
    component: AbstractIframe,
    props: { url: config.badDSAutres + "/consultation-bad?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  // {
  //   path: "Terminal/EntreeSortieConteneurs",
  //   component: AbstractIframe,
  //   props: { url: config.terminalEntreeSortie + "?" },
  //   roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  // },
  {
    path: "Terminal/EtatManifesteBad",
    component: AbstractIframe,
    props: { url: config.etatManifesteBad + "/list-manifeste-BAD?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  // EDIFACT
  {
    path: "EDIFACT/ValidationBAD",
    component: AbstractIframe,
    props: { url: config.edifact + "/edifact-upload?" },
    roles: ["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE", "ROLE_VUPORTUARIA_ADMIN"],
  },
  // badDS
  {
    path: "BadDSMead/Gestion",
    component: AbstractIframe,
    props: { url: config.badDSMead + "/gestion-bad?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "BadDSMead/Consultation",
    component: AbstractIframe,
    props: { url: config.badDSMead + "/consultation-bad?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_ADMIN", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },

  // Avis d'arrivée
  {
    path: "AvisArrivee/Consultation",
    component: AbstractIframe,
    props: { url: config.consultationAvis + "?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },

  // Manifeste
  {
    path: "Manifeste/RegimeImport/Consultation",
    component: AbstractIframe,
    props: {
      url: config.consultationManifesteMaritime + "?regime=IMPORT&",
    },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "Manifeste/PassagersCroisieres",
    component: AbstractIframe,
    props: { url: config.manifestePassager + "/list?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },

  // Bon à délivrer Maritime
  {
    path: "BadMaritime/Gestion",
    component: AbstractIframe,
    props: { url: config.badMaritime + "/gestion-bad?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "BadMaritime/Consultation",
    component: AbstractIframe,
    props: { url: config.badMaritime + "/consultation-bad?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },

  // Gestion Bon de sortie
  {
    path: "BonSortie/Gestion",
    component: AbstractIframe,
    props: { url: config.bonSortie + "/listeBonSortie?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },

  // Visite et contrôle
  {
    path: "VisiteControle/MarchandiseParJour",
    component: AbstractIframe,
    props: { url: config.ficheSuiveuse + "/marchandiseParJour?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "VisiteControle/MarchandiseParJourHistorique",
    component: AbstractIframe,
    props: { url: config.ficheSuiveuse + "/marchandiseParJourHistorique?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },
  {
    path: "VisiteControle/FicheSuiveuse",
    component: AbstractIframe,
    props: { url: config.ficheSuiveuse + "/gestionFs?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },

  // Main levée
  {
    path: "MainLevee/Liste",
    component: AbstractIframe,
    props: { url: config.mainLevee + "/listeDum?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },

  // Exportation - Préavis d'arrivée des TCs au port
  {
    path: "Exportation/PreavisArrivee/Nouveau",
    component: AbstractIframe,
    props: { url: config.pravisArrive + "/createPreavis?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Exportation/PreavisArrivee/Gestion",
    component: AbstractIframe,
    props: { url: config.pravisArrive + "/gestionPreavis?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Exportation/PreavisArrivee/Consultation",
    component: AbstractIframe,
    props: { url: config.pravisArrive + "/consultationPreavis?" },
    roles: ["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  // Exportation - ICS2 UE (Freight Forwarder)
  // {
  //   path: "Exportation/ICS2UE/Nouveau",
  //   component: AbstractIframe,
  //   props: { url: config.ics2Ue + "/ics/declaration/create?" },
  //   roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  // },
  // {
  //   path: "Exportation/ICS2UE/Liste",
  //   component: AbstractIframe,
  //   props: { url: config.ics2Ue + "/ics/declaration?" },
  //   roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  // },
  // Importation - Prise de RDV (Freight Forwarder)
  {
    path: "Importation/PriseRDV/Conteneurs/Nouveau",
    component: AbstractIframe,
    props: { url: config.rdvImport + "/prendre-rendez-vous?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Importation/PriseRDV/Conteneurs/Gestion",
    component: AbstractIframe,
    props: { url: config.rdvImport + "/gestion-rendez-vous?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Importation/PriseRDV/Conteneurs/Consultation",
    component: AbstractIframe,
    props: { url: config.rdvImport + "/consultation-rendez-vous?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },

  // Souscription des navires
  {
    path: "SouscriptionNavires/Gestion",
    component: AbstractIframe,
    props: { url: config.souscriptionNavires + "/?" },
    roles: ["ROLE_VUPORTUARIA_MEAD"],
  },

  // Consultations - Freight Forwarder
  {
    path: "Consultations/HistoriqueConteneurs",
    component: AbstractIframe,
    props: { url: config.suiviConteneur + "/suiviConteneurs?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },

  // Paramétrage - Freight Forwarder
  {
    path: "Parametrage/GestionProcurationsTransitaires",
    component: AbstractIframe,
    props: { url: config.procurationTransitaire + "/procuration/list?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Parametrage/GestionProcurationsDouane",
    component: AbstractIframe,
    props: { url: config.procurationDouane + "/procuration/ListeProcuration?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Parametrage/SuiviEtatsProcurations",
    component: AbstractIframe,
    props: { url: config.procurationTransitaire + "/etatsProcurations?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },

  // Factures - Freight Forwarder
  {
    path: "Factures/NouvelleDemandeFacture/FacturesMarsaMaroc",
    component: AbstractIframe,
    props: { url: config.facturesMarsaMaroc + "/factures-marsa-maroc?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Factures/GestionFactures",
    component: AbstractIframe,
    props: { url: config.epaiement + "/gestion-factures?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "Factures/ConsultationFactures",
    component: AbstractIframe,
    props: { url: config.epaiement + "/consultation-factures?" },
    roles: ["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"],
  },
  {
    path: "/AvisArrivee/Consultation",
    component: AbstractIframe,
    props: { url: config.avArurl + "/consultation/?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR",
    ],
  },
  {
    path: "/AvisArrivee/Gestion",
    component: AbstractIframe,
    props: { url: config.avArurl + "/gestion/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },

  
  // ///
  {
    path: "/Douane/DUM",
    component: AbstractIframe,
    props: { url: config.dumUrl + "/listeDum?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/Douane/MEAD",
    component: AbstractIframe,
    props: { url: config.dumUrl + "/listeDum?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/Douane/MainLevee",
    component: AbstractIframe,
    props: { url: config.dumUrl + "/listeDum?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/Consultations/CalendrierVisites",
    component: AbstractIframe,
    props: { url: config.visiteCalendrierUrl + "/?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR",
    ],
  },


  {
    path: "/Consultations/SuiviLMD-LMS",
    component: AbstractIframe,
    props: { url: config.urlDAP + "/suiviConsignes?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR",
    ],
  },

  {
    path: "/Manifeste/RegimeImport/Consultation",
    component: AbstractIframe,
    props: { url: config.manMarImpurl + "/list-manifeste-import/?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR",
    ],
  },

  {
    path: "/Manifeste/RegimeExportAutres/Gestion",
    component: AbstractIframe,
    props: { url: config.manMarExpUrl + "/list-manifeste-export/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },

  {
    path: "/Manifeste/RegimeExportAutres/Consultation",
    component: AbstractIframe,
    props: { url: config.manMarExpUrl + "/list-manifeste-export/?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR",
    ],
  },



  /////////////////////////




  {
    path: "/demandeAttributionPost/Consultation",
    component: AbstractIframe,
    props: { url: config.demandeAttrPostUrl + "/listDap/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/demandeAttributionPost/Gestion",
    component: AbstractIframe,
    props: { url: config.demandeAttrPostUrl + "/listDap/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/mouvement-navire",
    component: AbstractIframe,
    props: { url: config.mvmNavireUrl + "/mouvement-des-navires/?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR"
    ],
  },
  {
    path: "/plan-general-mouvements",
    component: AbstractIframe,
    props: { url: config.pgmUrl + "/consulter-pgm/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/dum-ml",
    component: AbstractIframe,
    props: { url: config.dumUrl + "/listeDum/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/preavis-arrivee",
    component: AbstractIframe,
    props: { url: config.preavisUrl + "/consultationPreavis/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/bad",
    component: AbstractIframe,
    props: { url: config.badUrl + "/consultation-bad/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/sequence-export/creation",
    component: AbstractIframe,
    props: { url: config.sequenceUrl + "/sequence-export/?" },
    roles: ["ROLE_VUPORTUARIA_CONSIGNATARIO"],
  },
  {
    path: "/sequence-export/gestion",
    component: AbstractIframe,
    props: { url: config.sequenceUrl + "/ListSequenceExport/?" },
    roles: ["ROLE_VUPORTUARIA_CONSIGNATARIO"],
  },
  {
    path: "/sequence-export/consultation",
    component: AbstractIframe,
    props: { url: config.sequenceUrl + "/consultationListSequenceExport/?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR"
    ],
  },
  {
    path: "/validation-bad",
    component: AbstractIframe,
    props: { url: config.edifact + "/edifact-upload/?" },
    roles: [
      "ROLE_VUPORTUARIA_OPERADOR"
    ],
  },
  {
    path: "/recepisses",
    component: AbstractIframe,
    props: { url: config.oniclUrl + "/recepisses/list/?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  // Cereales
  {
    path: "/Cereales/Gestion",
    component: AbstractIframe,
    props: { url: config.cerealierUrl + "/listRapport?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/Cereales/Parametrage",
    component: AbstractIframe,
    props: { url: config.cerealierUrl + "/parametragePort?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/Cereales/Situation",
    component: AbstractIframe,
    props: { url: config.cerealierUrl + "/listSituationJournaliere?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/Cereales/Generation",
    component: AbstractIframe,
    props: { url: config.cerealierUrl + "/generationRapport?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  // Vrac
  {
    path: "/Vrac/Gestion",
    component: AbstractIframe,
    props: { url: config.reportTracUrl + "/listRapport?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },
  {
    path: "/Vrac/Generation",
    component: AbstractIframe,
    props: { url: config.reportTracUrl + "/GenerationRapport?" },
    roles: ["ROLE_VUPORTUARIA_OPERADOR"],
  },

    // Opérateur de manutention — LISTE_MODULES_CCS_ROLE_OPERATEUR
    {
      path: "/Operateur/FicheSuiveuse/MarchandisesParJour",
      component: AbstractIframe,
      props: { url: config.ficheSuiveuseUrl + "/marchandiseParJour?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/Operateur/FicheSuiveuse/MarchandisesHistorique",
      component: AbstractIframe,
      props: { url: config.ficheSuiveuseUrl + "/marchandiseParJourHistorique?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/Operateur/FicheSuiveuse/ConteneursInspectesParJour",
      component: AbstractIframe,
      props: { url: config.ficheSuiveuseUrl + "/conteneursInspecteParJour?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvConteneur/Gestion",
      component: AbstractIframe,
      props: { url: config.prdvConteneurUrl + "/gestion-rendez-vous?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvConteneur/Consultation",
      component: AbstractIframe,
      props: { url: config.prdvConteneurUrl + "/consultation-rendez-vous?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvVrac/Affaire/Nouvelle",
      component: AbstractIframe,
      props: { url: config.priseRdvVracUrl + "/create-affaire?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvVrac/Affaire/Consultation",
      component: AbstractIframe,
      props: { url: config.priseRdvVracUrl + "/list-affaire?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvVrac/CommandeSortie/Gestion",
      component: AbstractIframe,
      props: { url: config.priseRdvVracUrl + "/gestion-commande-sortie?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvVrac/CommandeSortie/Consultation",
      component: AbstractIframe,
      props: { url: config.priseRdvVracUrl + "/consultation-commande-sortie?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/Manifeste/RegimeImport/Gestion",
      component: AbstractIframe,
      props: { url: config.manMarImpurl + "/list-manifeste-import?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalBooking/Consultation",
      component: AbstractIframe,
      props: { url: config.booking + "/gestion?action=consult&" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvVrac/Rdv/Gestion",
      component: AbstractIframe,
      props: { url: config.priseRdvVracUrl + "/list-vrac/gestion?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/RdvVrac/Rdv/Consultation",
      component: AbstractIframe,
      props: { url: config.priseRdvVracUrl + "/list-vrac/consultation?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/Pesage/Liste",
      component: AbstractIframe,
      props: { url: config.pesageUrl + "/listePesages?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },
    {
      path: "/TerminalOperateur/BonSortie/Liste",
      component: AbstractIframe,
      props: { url: config.bonSortieUrl + "/listeBonSortie?" },
      roles: ["ROLE_VUPORTUARIA_OPERADOR"],
    },

    {
      path: "/Factures/nouvelle-demande-dgsn",
      component: AbstractIframe,
      props: {
        url: config.paiement + "/dgsn-demande/create?",
      },
      roles: ["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"],
    },
    
    {
      path: "/Factures/consultation-demande-dgsn",
      component: AbstractIframe,
      props: {
        url: config.paiement + "/gestion-dgsnDemandes?",
      },
      roles: ["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"],
    },
    {
      path: "/Factures/gestion-factures",
      component: AbstractIframe,
      props: {
        url: config.paiement + "/gestion-factures?",
      },
      roles: ["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"],
    },
    {
      path: "/Factures/consultation-factures",
      component: AbstractIframe,
      props: {
        url: config.paiement + "/consultation-factures?",
      },
      roles: [
        "ROLE_VUPORTUARIA_FACTURAS_CLIENTE",
        "ROLE_VUPORTUARIA_FACTURAS_EMISOR",
      ],
  
    },
  
];

export default routesConfig;
